export enum NewSignupPageSectionEnum {
  POST_SIGN_UP_PAGE = 'postSignUpPage',
  CREATE_ORGANISATION = 'createOrganisation',
  ADDRESS = 'address',
  COMPLETED = 'COMPLETED',
}
